// redux/reducer.js
import { SET_SELECTED_LOCATION, SET_LOCATIONS } from '../actions/LocationDropdown';

const initialState = {
  selectedLocation: null,
  locations: [],
};

export const locationDropdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation: action.payload,
      };
    case SET_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      };
    default:
      return state;
  }
};

//export default locationDropdownReducer;